<template>
  <vuestic-widget
    class="details-wrapper"
    :header-text="$t(`trip.expenses.title`)"
  >
    <div
      slot="header"
      class="full-width"
      :tripId="tripData.id"
    >
      <div class="title-layout">
        <div class="title-left">
          <div>{{ $t(`trip.expenses.title`) }}</div>
        </div>
      </div>
    </div>
    <div>
      <div class="va-row ">
        <div class="form-group with-icon-left flex full-width">
          <div class="row filters-page__filter-bar-container title-layout">
            <vuestic-simple-select
              class="filters-page__filter-bar flex md3"
              :label="$t('trip.expenses.documentDescription')"
              option-key="name"
              v-model="filterExpensesDescription"
              :options="filterExpensesDescriptions"
            />
            <div class="form-group flex md2">
              <div class="input-group">
                <vuestic-date-picker
                  id="tripDurationFrom"
                  v-model="filterStartDate"
                  :config="dateConfig"
                />
                <label
                  class="control-label"
                  for="tripDurationFrom"
                >{{ $t('trip.create.durationFrom') }}</label>
                <i class="bar" />
              </div>
            </div>

            <div class="form-group flex md2">
              <div class="input-group">
                <vuestic-date-picker
                  id="tripDurationTo"
                  v-model="filterEndDate"
                  :config="dateConfig"
                />
                <label
                  class="control-label"
                  for="tripDurationTo"
                >{{ $t('trip.create.durationTo') }}</label>
                <i class="bar" />
              </div>
            </div>
            <vuestic-simple-select
              class="filters-page__filter-bar flex md2"
              :label="$t('trip.expenses.documentType')"
              option-key="name"
              v-model="filterExpensesType"
              :options="filterExpensesTypes"
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="va-row flex">
        <div class="flex">
          <div class="va-row">
            <span class="flex title bold table-body filters-page__table-heading">{{$t('trip.expenses.stats.summary')}}: </span>
          </div>
          <div class="va-row">
            <div style="padding-bottom: 20px;">
              <ul class="horizontal-list">
                <li v-for="(value, key) in statistics" :key="key" v-if="!value.isHidden">
                  <stats :stats="value" />
                </li>
                <li>
                  <div class="chart-container">
                    <vuestic-chart v-bind:data="chartData"
                                  type="donut"></vuestic-chart>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="va-row">

          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="va-row flex" style="padding-top: 20px;">
        <div class="flex">
          <div class="va-row">
            <span class="flex title bold table-body filters-page__table-heading md9">
              {{ $t("trip.expenses.subtitle") }}
            </span>
            <button
                class="btn btn-secondary btn-micro pull-left"
                @click="addExpense(tripId)"
              >{{$t("trip.expenses.addExpense")}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- expenses table -->
    <div class="table-responsive" style="padding-top: 20px;">
      <table class="table table-striped first-td-padding">
        <thead>
          <tr>
            <td class="filters-page__table-heading">
              {{ $t('trip.expenses.documentType') }}
            </td>
            <td class="filters-page__table-heading">
              {{ $t('trip.expenses.documentNumber') }}
            </td>
            <td
              class="filters-page__table-heading"
              align="center"
            >
              {{ $t('trip.expenses.documentIssueDate') }}
            </td>
            <td
              class="filters-page__table-heading"
              align="center"
            >
              {{ $t('trip.expenses.documentDescription') }}
            </td>
            <td
              class="filters-page__table-heading"
              align="center"
            >
              {{ $t('trip.expenses.documentMeasure') }}
            </td>
            <td class="filters-page__table-heading">
              {{ $t('trip.expenses.documentQantity') }}
            </td>
            <td class="filters-page__table-heading id-card">
              {{ $t('trip.expenses.documentPrice') }}
            </td>
            <td
              class="filters-page__table-heading passport"
              align="center"
            >
              {{ $t('trip.expenses.documentTotal') }}
            </td>
            <td
              class="filters-page__table-heading"
              align="center"
            >
              {{ $t('trip.expenses.documentNote') }}
            </td>
            <!-- <td
              class="filters-page__table-heading enrolmentType"
              align="center"
            >
              {{ $t('trip.expenses.documentAccounted') }}
            </td> -->
          </tr>
        </thead>
        <tbody class="table-body">
          <tr
            class="participant-row"
            v-for="expense in sortedExpenses"
            :key="expense.id"
          >
            <td class="row-index">
              <span>{{ convertDocumentTypeToLabel(expense.documentType) }}</span>
            </td>
            <td>
              <span>{{ expense.documentNumber }}</span>
            </td>
            <td align="center">
              <span>{{ convertToDate(expense.issueDate) }}</span>
            </td>
            <td align="center">
              <span>{{ convertDocumentDescriptionToLabel(expense.description) }}</span>
            </td>
            <td>
              <span>{{ expense.measure }}</span>
            </td>
            <td>
              <span>{{ expense.quantity }}</span>
            </td>
            <td
              class="passport-warning unselectable"
              align="center"
            >
              <span>{{ expense.price }}</span>
            </td>
            <!-- -->
            <td
              class="unselectable"
              align="center"
            >
              <span>{{ expense.price * expense.quantity }}</span>
            </td>
            <td
              class="unselectable"
              align="center"
            >
              <span>{{ expense.priceNotes }}</span>
            </td>
            <!-- <td
              class="visa-warning unselectable"
              align="center"
            >
              <span
                aria-hidden="true"
                class="sidebar-menu-item-icon glyphicon glyphicon-check"
                style="font-size: 20px;"
              />
            </td> -->
            <td class="payments-btn-wrapper" align="center">
              <span
                aria-hidden="true"
                class="show-on-hover sidebar-menu-item-icon glyphicon glyphicon-pencil"
                style="margin-left: 10px; font-size: 20px;cursor:pointer"
                @click="editExpense(tripId, expense.id)"
              />
            </td>
            <td align="right">
              <span
                aria-hidden="true"
                class="show-on-hover sidebar-menu-item-icon glyphicon glyphicon-trash"
                style="margin-left: 10px; font-size: 20px;cursor:pointer"
                @click="deleteExpense(tripId, expense.id)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <vuestic-modal
      :noButtons="true"
      v-bind:force="true"
      ref="expenseModal"
      :cancelClass="'none'"
      @cancel="closeAddExpenseDialog"
    >
      <div
        slot="title"
      >
        {{ $t('trip.expenses.addExpense') }}
      </div>
      <expense-editor
        :key="101"
        :trip-id="+tripId"
        :expenseData="selectedExpense"
        @add-expense="addNewExpense"
        @update-expense="updateExpense"
      />
    </vuestic-modal>
  </vuestic-widget>
</template>

<script>
import VuesticWidget from '../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget';
import { tripApi } from '../../../services/api/tripApi';
import { paymentApi } from '../../../services/api/paymentApi';
import {
  getEmptyTripData,
  isExpiringSoon,
  // dateLocale,
  formatCurrency
} from '../../../utils';
import { generateStatistic } from '../../../services/utils';
import ExpenseEditor from './Expense.vue';
import Stats from './Stats.vue';
import moment from 'moment';
import { dateLocaleBG, serverDateLocale } from '../../../utils';
export default {
  name: 'TripExpenses',
  components: {
    VuesticWidget,
    ExpenseEditor,
    Stats
  },
  props: {
    tripId: String
  },
  created() {
    return Promise.all([
      // tripApi.getTrip(this.tripId),
      tripApi.getAllExpenses(this.tripId)
    ])
      .then(data => {
        // this.tripData = data[0];
        this.expenses = data[0];
      })
      .then(() => {
        // chain some other operation if needed
      })
      .catch(er => console.log('Error:', er));
  },
  computed: {
    filteredExpenses() {
      let expensesType = this.filterExpensesType != null ? this.filterExpensesType.id : null;
      let expensesDescription = this.filterExpensesDescription != null ? this.filterExpensesDescription.id : null;
      
      let startDate = this.filterStartDate;
      let endDate = this.filterEndDate;
      let from = null;
      let to = null;
      if (startDate !== '') {
        from = moment(startDate, dateLocaleBG).startOf('day').format(serverDateLocale);
      }
      if (endDate !== '') {
        to = moment(endDate, dateLocaleBG).format(serverDateLocale);
        // to = parseInt(to);
      }
      
      let expenses = this.expenses.filter(item => {
        if (expensesType != null && item.documentType !== expensesType) {
            return false;
        }

        if (expensesDescription != null && item.description !== expensesDescription) {
            return false;
        }
        console.log(`From: ${from} ${startDate}`);
        console.log(`To: ${to}`);
        console.log(`Issue:: ${item.issueDate}`);
        let itemDate = moment(item.issueDate).startOf('day').format(serverDateLocale);
        console.log(`Issue:: ${itemDate}`);
        if (from != null &&  itemDate < from) {
          return false;
        }
        
        if (to != null && itemDate > to) {
          return false;
        }
        

        return true;
      });

      return expenses;
    },
    sortedExpenses() {
      let expenses = this.filteredExpenses;
      // TODO: sort all expenses by ...
      return expenses;
    },
    statistics() {
      let filtered = this.filteredExpenses;
      let statistics = generateStatistic(filtered);
      return statistics;
    },
    chartData() {
      let filtered = this.filteredExpenses;
      let statistics = generateStatistic(filtered);

      let colorMap = {
        'exp-travel': '#ffff00',
        'exp-drivers': '#ff9900',
        'exp-hotel': '#e34a4a',
        'exp-tickets': '#ffb6c1',
        'exp-plain': '#8a63d2',
        'exp-insurance': '#0F52BA',
        'exp-package': '#4ab2e3',
        'exp-unknown': '#4ae387'
      };
      let labels = [];
      let bgColors = [];
      let rawData = [];
      Object.keys(statistics).forEach(key => {
        let element = statistics[key];
        if (!element.isHidden) {
          let expenseType = element.expenseType || 'undefined'
          rawData.push(element.totalPrice || 0);
          bgColors.push(colorMap[expenseType]);
          labels.push(this.$t(`trip.expenses.documentDescriptions.${expenseType}`));
        } else {
          console.log("skip it!");
        }
      });

      let data = {
        labels,
        datasets: [{
          label: 'Разходи',
          backgroundColor: bgColors,
          data: rawData,
        }],
      };
      return data;
    }
  },
  data() {
    return {
      tripData: getEmptyTripData(),
      filterExpensesType: null,
      filterExpensesDescription: null,
      filterExpensesDescriptions: [
        { id: 'exp-travel', name: this.$t('trip.expenses.documentDescriptions.exp-travel') },
        { id: 'exp-drivers', name: this.$t('trip.expenses.documentDescriptions.exp-drivers') },
        { id: 'exp-hotel', name: this.$t('trip.expenses.documentDescriptions.exp-hotel') },
        { id: 'exp-tickets', name: this.$t('trip.expenses.documentDescriptions.exp-tickets') },
        { id: 'exp-plain', name: this.$t('trip.expenses.documentDescriptions.exp-plain') },
        { id: 'exp-insurance', name: this.$t('trip.expenses.documentDescriptions.exp-insurance') },
        { id: 'exp-package', name: this.$t('trip.expenses.documentDescriptions.exp-package') },
        { id: 'exp-unknown', name: this.$t('trip.expenses.documentDescriptions.exp-unknown') }
      ],
      filterExpensesTypes: [
        { id: 'invoice', name: this.$t('trip.expenses.documentTypes.invoice') },
        { id: 'expense', name: this.$t('trip.expenses.documentTypes.expense') },
        { id: 'receipt', name: this.$t('trip.expenses.documentTypes.receipt') },
        { id: 'protocol', name: this.$t('trip.expenses.documentTypes.protocol') },
        { id: 'unknown', name: this.$t('trip.expenses.documentTypes.unknown') }
      ],
      filterStartDate: '',
      filterEndDate: '',
      newExpense: {},
      selectedExpense: null,
      expenses: [],
      rawExpenses: [],
      dateConfig: {
        dateFormat: 'd.m.Y',
        locale: { firstDayOfWeek: 1 }
      },
    };
  },
  methods: {
    convertHex: function (color, alpha) {
      color = color.replace('#', '')
      let r = parseInt(color.substring(0, 2), 16)
      let g = parseInt(color.substring(2, 4), 16)
      let b = parseInt(color.substring(4, 6), 16)
      let result = 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')'
      return result
    },
    /**
     * @param {{ association: any; role: string; }} participant
     */
    backgroundColorWithAlpha(participant) {
      let color = participant.association;
      let alpha = 0.19;
      let travelerRole = participant.role === 'traveller' || participant.role == null
      if (color === undefined || color === '' || color === 'none' || !travelerRole) {
        alpha = 0;
        color = '#FFFFFF';
      }
      return this.convertHex(color, alpha);
    },
    async refreshExpenses() {
      // TODO: implementation
      console.log('[TODO] refresh expenses');
    },
    /**
     * @param {number} amount
     */
    toCurrency(amount) {
          return new Intl.NumberFormat("bg-BG", {
          style: 'currency',
          currency: "EUR"
      }).format(amount);
    },
    addExpense(tripId) {
      console.log('Open a modal -> Add Expense to trip with id =', tripId);
      this.$refs.expenseModal.open();
    },
    /**
     * @param {number} tripId the trip id
     * @param {number} expenseId the expense id
     */
    editExpense(tripId, expenseId) {
      console.log(`Edit tripId = ${tripId}, expenseId = ${expenseId}`);
      let expenseData = this.selectedExpenseBy(expenseId);
      this.selectedExpense = expenseData;
      this.$refs.expenseModal.open();
    },
    /**
     * @param {number} tripId the trip id
     * @param {number} expenseId the expense id
     */
    deleteExpense(tripId, expenseId) {
      console.log(`Delete tripId = ${tripId}, expenseId = ${expenseId}`);
      let index = this.expenses.findIndex((item) => item.id === expenseId);
      if(index >= 0) {
        tripApi.removeExpense(this.tripId, expenseId)
        .then(expense => {
          this.expenses.splice(index, 1);
        });

      } else {
        console.log(`Unable to delete tripId = ${tripId}, expenseId = ${expenseId}`);
      }
    },
    // helper function
    /**
     * @param {any} date a date to be formatted
     */
    convertToDate(date) {
      return moment(date, 'X').format('DD-MM-YYYY');
    },
    /**
     * @param {string} documentType a date to be formatted
     * @returns {string} translated type
     */
    convertDocumentTypeToLabel(documentType) {
      let validDocTypes = ['invoice', 'expense', 'receipt', 'protocol', 'unknown'];
      if (validDocTypes.indexOf(documentType) < 0) {
        documentType = 'unknown';
      }
      return this.$t(`trip.expenses.documentTypes.${documentType}`);
    },
        /**
     * @param {string} documentDescription a date to be formatted
     * @returns {string} translated type
     */
     convertDocumentDescriptionToLabel(documentDescription) {
      let validDocTypes = ['exp-travel','exp-drivers','exp-hotel', 'exp-tickets', 'exp-plain', 'exp-insurance', 'exp-package', 'exp-unknown'];
      if (validDocTypes.indexOf(documentDescription) < 0) {
        documentDescription = 'exp-unknown';
      }
      return this.$t(`trip.expenses.documentDescriptions.${documentDescription}`);
    },
    /**
     * @param {number} expenseId the id of the selected expense
     * @returns {any} expense
     */
    selectedExpenseBy(expenseId) {
      return this.expenses.find((item) => item.id === expenseId);
    },
    findIndexById(expenseId) {
      for (let i = 0; i < this.expenses.length; i++) {
        if (this.expenses[i].id === expenseId) {
          return i;
        }
      }
      return -1; // return -1 if the element with the given id is not found
    },
    async closeAddExpenseDialog() {
      console.log('[TODO] Steps upon close.');
      this.selectedExpense = null;
    },
    /**
     * @param {any} expenseData an object that contains an expens data
     */
    async addNewExpense(expenseData) {
      // console.log('[TODO] Add new expense.', expenseData);
      // this.isLoading = true;
      this.selectedExpense = null;
      this.$refs.expenseModal.close();
      tripApi.createExpense(this.tripId, expenseData)
        .then(expense => {
          //this.expenses.push(expense);
          this.$set(this.expenses, this.expenses.length, expense);
        })
        .catch(er => {
          console.log("Error:", er);
        });
      // this.refreshExpenses();
    },
    /**
     * @param {any} expenseData an object that contains an expens data
     */
    async updateExpense(updateEvent) {
      let expenseId = this.selectedExpense.id;
      tripApi.updateExpenseField(this.tripId, expenseId, updateEvent.field, updateEvent.value)
        .then(expense => {
          let expenseData = this.selectedExpense;
          // expenseData[updateEvent.field] = updateEvent.value;
          let index = this.findIndexById(expenseId);
          // this.expenses[index] = expenseData; // local data
          // this.expenses[index] = expense; // data from server
          console.log(`${index} + ${JSON.stringify(expense)}`);
          this.$set(this.expenses, index, expense);
          console.log("item was updated!");
        });
    },
    deepEqual(obj1, obj2) {
      if (obj1 === obj2) {
        return true;
      }

      if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 == null || obj2 == null) {
        return false;
      }

      var keys1 = Object.keys(obj1);
      var keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (var i = 0; i < keys1.length; i++) {
        var key = keys1[i];

        if (!obj2.hasOwnProperty(key)) {
          return false;
        }

        if (!deepEqual(obj1[key], obj2[key])) {
          return false;
        }
      }

      return true;
    },
    triggerSearch() {
      let expensesDescription = this.filterExpensesDescription != null ? this.filterExpensesDescription.id : '';
      let expensesType = this.filterExpensesType != null ? this.filterExpensesType.id : '';
      let startDate = this.filterStartDate;
      let endDate = this.filterEndDate;
      let from = '';
      let to = '';
      if (startDate !== '') {
        from = moment(startDate, dateLocaleBG).format(serverDateLocale);
      }
      if (endDate !== '') {
        to = moment(endDate, dateLocaleBG).format(serverDateLocale);
        // to = parseInt(to);
      }
      // this.isLoading = true;
      // tripApi.search(searchText, from, to, status, this.pagination)
      //   .then(response => {
      //     this.trips = response.trips;
      //     this.showLoadMore = response.count > this.pagination.perPage;
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   })
      //   .finally(() => {
      //     this.isLoading = false;
      //   });
    },
  },
  watch: {
    filterExpensesType: {
      handler() {
        this.triggerSearch();
      },
    },
    filterExpensesDescription: {
      handler() {
        this.triggerSearch();
      },
    },
    tripStartDate: {
      handler() {
        this.triggerSearch();
      },
    },
    tripEndDate: {
      handler() {
        this.triggerSearch();
      },
    },
  },
};
</script>

<style lang="scss">
.details-wrapper {
  .date-title {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .show-on-hover {
    visibility: hidden;
  }

  .participant-row:hover .show-on-hover {
    visibility: visible;
  }

  .table-body {
    font-size: 1.2rem;
  }

  .currency {
    display: flex;
    align-self: flex-end;
  }

  .warning-container {
    border: 2px solid;
    height: 32px;
    border-radius: 16px;
    padding: 5px 14px;
    display: -webkit-box;
    display: flex;
    justify-content: center;
    align-items: center;

    & span {
      width: 100%;
    }
  }

  .link:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  .unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .display-flex {
    display: flex;
  }

  .action-hover:hover {
    cursor: pointer;
  }

  .declined {
    text-decoration: line-through red;
  }

  .row-index {
    position: relative;

    & .fa-close {
      position: absolute;
      font-size: 25px;
      right: 20%;
      color: red;
    }
  }

  .dot {
    height: 25px;
    width: 25px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
  }

  .title-layout {
    display: flex;
    justify-content: space-between;
  }

  .title-left {
    display: flex;
    justify-content: space-between;
  }
  .full-width {
    width:100%
  }
  .horizontal-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .horizontal-list li {
    display: inline-block;
    margin-right: 10px;
  }
  .form-group {
    margin-bottom: 10px;
  }
}
</style>
